import 'cropperjs/dist/cropper.css';
import React from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import ReactDOM from 'react-dom';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import './styles.scss';

ReactDOM.render(
  <React.Fragment>
    <App />
    <ToastContainer limit={1} hideProgressBar />
  </React.Fragment>,
  document.getElementById('root')
);
